// extracted by mini-css-extract-plugin
export default {"component":"He8sz","icon":"rUD1r"};